function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 8.5V28L0 32V14.5L6 8.5Z",
  fill: "url(#paint0_liner_1_1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 26L24 32H0L6 26H18Z",
  fill: "url(#paint1_linear_1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 0.5L24 18.5V32L18 28V20.5L6 8.5V0.5Z",
  fill: "url(#paint2_linear_1)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_liner_1_1",
  x1: 3,
  y1: 32,
  x2: 3,
  y2: 8.06266,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#D45CAD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C964CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1",
  x1: 0,
  y1: 29,
  x2: 24,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#D45CAD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#E3527E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1",
  x1: 15,
  y1: 32,
  x2: 15,
  y2: 0.0626214,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1875,
  stopColor: "#E3527E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F9423A"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 166,
  height: 36,
  fill: "white"
})));

var SvgPacs = function SvgPacs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPacs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pacs.67c458bb.svg";
export { ForwardRef as ReactComponent };